import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=af9c1cd6&scoped=true&"
import script from "./detailInfo.vue?vue&type=script&lang=js&"
export * from "./detailInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=af9c1cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9c1cd6",
  null
  
)

export default component.exports